const Backdrop =()=>{
    return (<div className='backdrop-blur-sm z-10 opacity-50 w-full h-full bg-black absolute '/>)
         
 }
 export default Backdrop
